import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const ValueAdd = () => {
  const theme = useTheme();

  const items = [
    {
      title: 'Autoridad de Formato',
      text: 'Danimar se posiciona en una narrativa de investigación, no en publicidad tradicional. Eso eleva percepción de marca y recordación.',
    },
    {
      title: 'Ejecución Premium en Estudio',
      text: 'Producción de alto nivel visual en el set de Expedientes del Delito, con integración elegante del producto y guion de impacto.',
    },
    {
      title: 'Conversión por Confianza',
      text: 'El mensaje llega desde voces con credibilidad periodística. La audiencia percibe a Danimar como solución técnica y comprobable.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Ventajas
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          ¿Por qué Danimar debe elegir a TNO Network?
        </Box>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ValueAdd;

